export const pingCountStorageKey = "total_ipm_pings";
export var DataType;
(function (DataType) {
    DataType["customer"] = "customer";
    DataType["device"] = "device";
    DataType["event"] = "event";
})(DataType || (DataType = {}));
export var PlatformType;
(function (PlatformType) {
    PlatformType["web"] = "web";
})(PlatformType || (PlatformType = {}));
export var LicenseState;
(function (LicenseState) {
    LicenseState["active"] = "premium";
    LicenseState["inactive"] = "free";
})(LicenseState || (LicenseState = {}));
export var PlatformStatus;
(function (PlatformStatus) {
    PlatformStatus["true"] = "true";
})(PlatformStatus || (PlatformStatus = {}));
export const eventStorageKey = "ipm_events";
